import DashboardTypes from 'store/actionTypes/dashboard'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  monthlyTripStatistics: [],
  monthlyDigitalKeyStatistics: [],
  monthlyRiderStatistics: [],
  monthlyRiderSubscriptionsStatistics: [],
  monthlyAlertStatistics: [],
  monthlyPersActivityStatistics: [],
  monthlyDirectVehicleStatistics: [],
  monthlyRiderPermanentSharingsStatistics: [],
  monthlyRiderTemporarySharingsStatistics: [],
  monthlyCompanyStatistics: [],
  currentDataCompanyStatistics: {},
  currentRidersStatistics: {},
  ridersDashboardStatistics: {},
  riderPerCountry: [],
  monthlyManufacturerPersReceptionStatistics: [],
  monthlySubcontractorPersReceptionStatistics: [],
  monthlyProducedVehiclesStatistics: [],
  detailRealtimeAlerts: [],
  filterDetailRealtimeAlerts: {}
}

const dashboard = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case DashboardTypes.GET_MONTHLY_TRIP_STATISTICS_SUCCESS:
      return {
        ...state,
        monthlyTripStatistics: payload?.statistics || []
      }
    case DashboardTypes.GET_MONTHLY_TRIP_STATISTICS_FAILED:
      return {
        ...state,
        monthlyTripStatistics: []
      }
    case DashboardTypes.GET_MONTHLY_DIGITAL_KEY_STATISTICS_SUCCESS:
      return {
        ...state,
        monthlyDigitalKeyStatistics: payload?.statistics || []
      }
    case DashboardTypes.GET_MONTHLY_DIGITAL_KEY_STATISTICS_FAILED:
      return {
        ...state,
        monthlyDigitalKeyStatistics: []
      }
    case DashboardTypes.GET_MONTHLY_RIDER_STATISTICS_SUCCESS:
      return {
        ...state,
        monthlyRiderStatistics: payload?.statistics || []
      }
    case DashboardTypes.GET_MONTHLY_RIDER_STATISTICS_FAILED:
      return {
        ...state,
        monthlyRiderStatistics: []
      }
    case DashboardTypes.GET_MONTHLY_RIDER_SUBSCRIPTIONS_STATISTICS_SUCCESS:
      return {
        ...state,
        monthlyRiderSubscriptionsStatistics: payload?.statistics || []
      }
    case DashboardTypes.GET_MONTHLY_RIDER_SUBSCRIPTIONS_STATISTICS_FAILED:
      return {
        ...state,
        monthlyRiderSubscriptionsStatistics: []
      }
    case DashboardTypes.GET_MONTHLY_ALERT_STATISTICS_SUCCESS:
      return {
        ...state,
        monthlyAlertStatistics: payload?.statistics || []
      }
    case DashboardTypes.GET_MONTHLY_PERS_ACTIVITY_STATISTICS_SUCCESS:
      return {
        ...state,
        monthlyPersActivityStatistics: payload?.statistics || []
      }
    case DashboardTypes.GET_MONTHLY_PERS_ACTIVITY_STATISTICS_FAILED:
      return {
        ...state,
        monthlyPersActivityStatistics: []
      }
    case DashboardTypes.GET_MONTHLY_DIRECT_VEHICLE_STATISTICS_SUCCESS:
      return {
        ...state,
        monthlyDirectVehicleStatistics: payload?.statistics || []
      }
    case DashboardTypes.GET_MONTHLY_RIDER_PERMANENT_SHARINGS_STATISTICS_SUCCESS:
      return {
        ...state,
        monthlyRiderPermanentSharingsStatistics: payload?.statistics || []
      }
    case DashboardTypes.GET_MONTHLY_RIDER_PERMANENT_SHARINGS_STATISTICS_FAILED:
      return {
        ...state,
        monthlyRiderPermanentSharingsStatistics: []
      }
    case DashboardTypes.GET_MONTHLY_RIDER_TEMPORARY_SHARINGS_STATISTICS_SUCCESS:
      return {
        ...state,
        monthlyRiderTemporarySharingsStatistics: payload?.statistics || []
      }
    case DashboardTypes.GET_MONTHLY_RIDER_TEMPORARY_SHARINGS_STATISTICS_FAILED:
      return {
        ...state,
        monthlyRiderTemporarySharingsStatistics: []
      }
    case DashboardTypes.GET_MONTHLY_COMPANY_STATISTICS_SUCCESS:
      return {
        ...state,
        monthlyCompanyStatistics: payload?.statistics || []
      }
    case DashboardTypes.GET_CURRENT_DATA_COMPANY_STATISTICS_SUCCESS:
      return {
        ...state,
        currentDataCompanyStatistics: payload?.currentData || {}
      }
    case DashboardTypes.GET_CURRENT_RIDERS_STATISTICS_SUCCESS:
      return {
        ...state,
        currentRidersStatistics: payload?.currentData || {}
      }
    case DashboardTypes.GET_CURRENT_RIDERS_STATISTICS_FAILED:
      return {
        ...state,
        currentRidersStatistics: {}
      }
    case DashboardTypes.GET_RIDERS_DASHBOARD_STATISTICS_SUCCESS:
      return {
        ...state,
        ridersDashboardStatistics: payload?.currentRidersStatistics || {},
        riderPerCountry: payload?.riderPerCountry || []
      }
    case DashboardTypes.GET_RIDERS_DASHBOARD_STATISTICS_FAILED:
      return {
        ...state,
        ridersDashboardStatistics: {},
        riderPerCountry: []
      }
    case DashboardTypes.GET_MONTHLY_MANUFACTURER_PERS_RECEPTION_STATISTICS_SUCCESS:
      return {
        ...state,
        monthlyManufacturerPersReceptionStatistics: payload?.statistics || []
      }

    case DashboardTypes.GET_MONTHLY_SUBCONTRACTOR_PERS_RECEPTION_STATISTICS_SUCCESS:
      return {
        ...state,
        monthlySubcontractorPersReceptionStatistics: payload?.statistics || []
      }
    case DashboardTypes.GET_MONTHLY_PRODUCED_VEHICLES_STATISTICS_SUCCESS:
      return {
        ...state,
        monthlyProducedVehiclesStatistics: payload?.statistics || []
      }
    case DashboardTypes.GET_DETAIL_REALTIME_ALERTS_SUCCESS:
      return {
        ...state,
        detailRealtimeAlerts: payload?.items || []
      }
    case DashboardTypes.UPDATE_FILTER_DETAIL_REALTIME_ALERTS_SUCCESS:
      return {
        ...state,
        filterDetailRealtimeAlerts: payload || {}
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default dashboard
